import React from 'react'
import PropTypes from 'prop-types'
import {Typography} from '@mui/material'

export default function Version(props) {
    const {version} = props;
    const p = require('../package.json');
    const uiVersion = p.version;
    return <Typography variant="caption">x10trader: {version}, ui: {uiVersion}</Typography>
}

Version.propTypes = {
    version: PropTypes.string.isRequired,
}
